import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import Contracts from '../pages/Contracts';
import Courses from '../pages/Courses';
import FAQ from '../pages/FAQ';
import FAQForm from '../pages/FAQForm';
import Home from '../pages/Home';
import Login from '../pages/Login';
import NotFound from '../pages/NotFound';
import ProfilePage from '../pages/ProfilePage';
import RedirectRoute from '../components/RedirectRoute';
import RemindMe from '../pages/RemindMe';

import SessionProvider from '../providers/SessionProvider';

function MainRoutes() {
  return (
    <Router>
      <SessionProvider>
        <Switch>
          <Route path="/" exact component={Login} />
          <Route path="/lembrete" exact component={RemindMe} />
          <RedirectRoute path="/home" exact component={Home} />
          <RedirectRoute path="/profile" exact component={ProfilePage} />
          <RedirectRoute path="/contracts" exact component={Contracts} />
          <RedirectRoute path="/faq" exact component={FAQ} />
          <RedirectRoute path="/faq/send" exact component={FAQForm} />
          <RedirectRoute path="/courses" exact component={Courses} />
          <Route path="*" component={NotFound} />
        </Switch>
      </SessionProvider>
    </Router>
  );
}

export default MainRoutes;
